<script setup>
  const props = defineProps({
    grayscale: Boolean,
    grayscaleAccent: Boolean,
    prefix: Boolean,
    suffix: Boolean,
    plus: Boolean,
    arrow: Boolean,
    disabled: Boolean
  })
  const emits = defineEmits([ 'click' ])
</script>

<template>
  <div class="base-button" :class="{ 'grayscale': props.grayscale, 'grayscale-accent': props.grayscaleAccent, 'disabled': props.disabled }" @click="emits('click')">
    <div v-if="prefix" class="base-button__prefix">
      <template v-if="plus">
        +
      </template>
      <template v-else>
        <slot name="prefix">
          prefix
        </slot>
      </template>
    </div>
    <span class="base-button__label">
      <slot name="label">
        label
      </slot>
    </span>
    <span v-if="suffix" class="base-button__suffix">
       <template v-if="arrow">
        >
      </template>
      <template v-else>
        suffix
      </template>
    </span>
  </div>
</template>

<style lang="scss" scoped>
  .base-button {
    width: 100%;

    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    padding: 16px;
    border-radius: 12px;

    background-color: var(--accent-bg);
    color: var(--text-color-primary-reverse);
    &.grayscale {
      color: var(--text-color);
      background-color: var(--layout-bg);
    };

    &.grayscale-accent {
      color: var(--text-color);
      background-color: var(--element-bg);
      transition: 0.3s ease all;

      &:hover {
        background-color: var(--accent-bg);
        transition: 0.3s ease all;
        color: var(--text-color-primary-reverse);
      }
    }

    &.disabled {
      pointer-events: none;
      color: var(--text-color-disabled);
      background-color: var(--element-bg);
    }

    cursor: pointer;

    font-size: 16px;
    font-weight: 500;

    .base-button__prefix {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .base-button__label {
      text-align: center;
    }
    .base-button__suffix {
      transition: transform 0.3s ease-out;
    }

    &:hover {
      .base-button__suffix {
        transform: translateX(5px);
      }
    }

    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;

    @media (min-width: 920px) {
      &.grayscale {
        background-color: var(--element-bg);
      };
    };
  }
</style>